var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorAgriculture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5 33.049V5.951C91.5 3.769 89.731 2 87.549 2H55.451C53.269 2 51.5 3.769 51.5 5.951V32H46.316C45.903 30.837 44.804 30 43.5 30C41.843 30 40.5 31.343 40.5 33C40.5 34.657 41.843 36 43.5 36C44.804 36 45.903 35.163 46.316 34H51.5V33.049C51.5 35.231 53.269 37 55.451 37H87.549C89.731 37 91.5 35.231 91.5 33.049ZM75.5 34H67.5V32H75.5V34ZM87.5 29H55.5V6H87.5V29Z",
    fill: "#5F7F04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.406 15.508L71.711 23.614C71.901 23.858 72.192 24 72.5 24C72.525 24 72.551 23.999 72.577 23.997C72.912 23.972 73.211 23.779 73.374 23.485L77.453 16.142L78.605 18.447C78.775 18.786 79.121 19 79.5 19H83.5V17H80.118L78.394 13.553C78.228 13.221 77.892 13.008 77.521 13C77.148 13 76.805 13.189 76.625 13.515L72.359 21.192L66.288 13.386C66.112 13.159 65.848 13.02 65.561 13.002C65.264 12.987 64.995 13.09 64.791 13.293L58.791 19.293L60.205 20.707L65.406 15.508Z",
    fill: "#5F7F04"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 39H67.5V43H75.5V39Z",
    fill: "#5F7F04"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 46V76C53.5 76.553 53.947 77 54.5 77H88.5C89.053 77 89.5 76.553 89.5 76V46C89.5 45.447 89.053 45 88.5 45H54.5C53.947 45 53.5 45.447 53.5 46ZM55.5 47H87.5V75H55.5V47Z",
    fill: "#5F7F04"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 51H58.5V68H64.5V51Z",
    fill: "#5F7F04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5 59H68.5V68H74.5V59Z",
    fill: "#5F7F04"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 54H78.5V68H84.5V54Z",
    fill: "#5F7F04"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 71H60.5V73H62.5V71Z",
    fill: "#5F7F04"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5 71H70.5V73H72.5V71Z",
    fill: "#5F7F04"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 71H80.5V73H82.5V71Z",
    fill: "#5F7F04"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5009 51.64L37.4619 51.247C36.6309 47.091 33.4089 43.869 29.2529 43.038L28.8599 44.999C32.2229 45.671 34.8289 48.277 35.5009 51.64Z",
    fill: "#5F7F04"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5821 54.234L32.4801 53.601C31.6061 50.979 29.5201 48.893 26.8981 48.019L26.2651 49.917C28.2941 50.593 29.9071 52.206 30.5821 54.234Z",
    fill: "#5F7F04"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4482 48.583C40.8002 43.637 36.8632 39.7 31.9172 38.052L31.2842 39.948C35.6372 41.399 39.1002 44.863 40.5522 49.216L42.4482 48.583Z",
    fill: "#5F7F04"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 16H20.5C22.709 16 24.5 14.209 24.5 12C24.5 9.791 22.709 8 20.5 8C20.147 8 19.811 8.06 19.485 8.146C19.487 8.096 19.5 8.05 19.5 8C19.5 5.239 17.261 3 14.5 3C11.739 3 9.5 5.239 9.5 8C9.5 8.047 9.513 8.091 9.514 8.137C8.443 8.41 7.555 9.112 7.026 10.053C6.855 10.023 6.68 10 6.5 10C4.843 10 3.5 11.343 3.5 13C3.5 14.657 4.843 16 6.5 16Z",
    fill: "#5F7F04"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5 78L43.5 77.375V73.931C47.445 73.438 50.5 70.079 50.5 66C46.421 66 43.062 69.055 42.569 73H42.431C41.938 69.055 38.579 66 34.5 66C34.5 70.079 37.555 73.438 41.5 73.931V77.125L40.5 77L35.5 79H32.5L29.5 80H27.5V86H26.332V74C26.332 73.803 26.273 73.609 26.164 73.445L24.5 70.949V63C24.5 59.686 21.814 57 18.5 57C15.186 57 12.5 59.686 12.5 63V70.949L10.836 73.445C10.727 73.609 10.668 73.802 10.668 74V86H9.5V80H7.5L2.5 78V94H94.5V80H52.5L48.5 78ZM17.5 62H19.5V64H17.5V62ZM12.5 90H10.5V88H12.5V90ZM13.5 80V86H12.5V74L13.318 73H17.5V86H16.5V80H13.5ZM19.5 90H17.5V88H19.5V90ZM20.5 80V86H19.5V73H23.552L24.5 74.303V86H23.5V80H20.5ZM26.332 90H24.332V88H26.332V90ZM44.5 90H40.5V88H44.5V90ZM86.5 87H90.5V89H86.5V87ZM68.5 84H73.5V86H68.5V84Z",
    fill: "#5F7F04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorAgriculture);
export default __webpack_public_path__ + "static/media/sensor-agriculture.859a01214afe94a55602f15aa5101c9e.svg";
export { ForwardRef as ReactComponent };